import { css } from 'styled-components';
import { spacing } from '../../style';
// colors
import colors from '../../style/colors';
import { actionLight, actionColorDark } from '../../style/theme-helpers';

const variants = {
  positive: css`
    background: ${colors.positiveBackground};
    color: ${colors.positiveDark};
  `,
  negative: css`
    background: ${colors.negativeBackground};
    color: ${colors.negativeDark};
  `,
  action: css`
    background: ${actionLight};
    color: ${actionColorDark};
  `,
  attention: css`
    background: ${colors.attentionBackground};
    color: ${colors.gray900};
    border: 1px solid ${colors.attention};
  `,
  gray900: css`
    background: ${colors.gray900};
    color: ${colors.white};
  `,
  default: css`
    background: ${colors.gray300};
    color: ${colors.gray900};
  `,
};

const borderRadiusOptions = {
  xs: {
    size: spacing.xxs,
  },
  none: {
    size: spacing.none,
  },
};

export { variants, borderRadiusOptions };
